import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '@libs/common/components';
import { SubmitGroupItemModel, SubmitItem } from '@libs/form/models';
import { ItemBaseComponent } from '../../../models';

@Component({
  selector: 'ui-form-submit',
  templateUrl: './submit-group.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonComponent,
  ],
})
export class SubmitGroupComponent extends ItemBaseComponent {
  @Input() public data!: SubmitGroupItemModel;
  @Output() public readonly submitted: EventEmitter<SubmitItem> = new EventEmitter<SubmitItem>();
}
